"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ElstrIo_1 = __importDefault(require("../ElstrIo"));
var className = "ELSTR_AuthServer";
function auth(username, password, enterpriseApplication) {
    if (enterpriseApplication === void 0) { enterpriseApplication = ""; }
    return ElstrUserService.auth(username, password, enterpriseApplication);
}
exports.auth = auth;
function logout() {
    return ElstrUserService.logout();
}
exports.logout = logout;
var ElstrUserService = /** @class */ (function () {
    function ElstrUserService() {
    }
    /**
     * Service method to handle auth request
     * If user can be authenticated, save user into session
     *
     * @param username
     * @param password
     * @param enterpriseApplication
     * @return Json Object
     */
    ElstrUserService.auth = function (username, password, enterpriseApplication) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, ElstrIo_1.default.requestJsonRpc(className, "auth", {
                                username: username,
                                password: password,
                                enterpriseApplication: enterpriseApplication,
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_1 = _a.sent();
                        return [2 /*return*/, new Error(e_1)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Service method to handle sso request
     * If user can be authenticated, save user into session
     *
     * @return Json Object
     */
    ElstrUserService.sso = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, ElstrIo_1.default.requestJsonRpc(className, "sso", {})];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_2 = _a.sent();
                        return [2 /*return*/, new Error(e_2)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Service method to handle logout request
     *
     * @return Json Object
     */
    ElstrUserService.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, ElstrIo_1.default.requestJsonRpc(className, "logout", {})];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_3 = _a.sent();
                        return [2 /*return*/, new Error(e_3)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Service method to handle user creation
     * Creates a new user
     *
     * @return Json Object
     */
    ElstrUserService.create = function (username, password) {
        return __awaiter(this, void 0, void 0, function () {
            var e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, ElstrIo_1.default.requestJsonRpc(className, "create", {
                                username: username,
                                password: password,
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_4 = _a.sent();
                        return [2 /*return*/, new Error(e_4)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Checks the group membership of the bound user
     *
     * @return Json Object
     */
    ElstrUserService.checkGroupMembership = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, ElstrIo_1.default.requestJsonRpc(className, "checkGroupMembership", {})];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_5 = _a.sent();
                        return [2 /*return*/, new Error(e_5)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return ElstrUserService;
}());
exports.default = ElstrUserService;
//# sourceMappingURL=ElstrUserService.js.map